import React from 'react';
import { useDispatch } from 'react-redux';
import Label from 'components/_utility/Label';
import { getGarageEmailAddress } from 'helpers/garage';
import useSaveToGarage from 'src/hooks/useSaveToGarage';
import { clearLoadedConfiguration } from 'src/redux/garage/actions';
import { Wrap, H4, ResetButton, ResetButtonWrapper, SubTitle, MainText } from './UnsavedConfigurationModal.styled';

const UnsavedConfigurationModal = ({
  isVerticalButtonAlignment,
  onSaveWithoutUser,
  onSaved,
  onSaving,
  onContinueWithoutSave,
  unsavedConfigurationTitle = 'unsavedConfigurationTitle',
  unsavedConfigurationSubtitle = 'unsavedConfigurationSubtitle',
  unsavedConfigurationDescription = 'unsavedConfigurationDescription',
  saveLabel = 'saveLabel',
  continueWithoutSavingLabel = 'continueWithoutSavingLabel',
}) => {
  const dispatch = useDispatch();
  const saveToGarage = useSaveToGarage();

  return (
    <Wrap>
      <H4>
        <Label name={unsavedConfigurationTitle} />
      </H4>
      <SubTitle>
        <Label name={unsavedConfigurationSubtitle} />
      </SubTitle>
      <MainText>
        <Label name={unsavedConfigurationDescription} />
      </MainText>
      <ResetButtonWrapper $vertical={isVerticalButtonAlignment}>
        <ResetButton
          primary
          onClick={() => {
            if (getGarageEmailAddress()) {
              onSaving();

              saveToGarage(null, null, null, () => {
                onSaved();
                dispatch(clearLoadedConfiguration());
              });
              return;
            }

            onSaveWithoutUser();
          }}
        >
          <Label name={saveLabel} />
        </ResetButton>
        <ResetButton
          onClick={() => {
            onContinueWithoutSave();
          }}
        >
          <Label name={continueWithoutSavingLabel} />
        </ResetButton>
      </ResetButtonWrapper>
    </Wrap>
  );
};

export default UnsavedConfigurationModal;
